import { PlusIcon } from 'lucide-react';

import { EmptyTableState } from '@nesso/ui/blocks/table/empty-table-state';
import { Button } from '@nesso/ui/primitives/button';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@nesso/ui/primitives/table';

export function ClientBillingSheetDocuments() {
    return (
        <section className="flex flex-col gap-8">
            <div className="flex items-center justify-between gap-2">
                <h3 className="text-xl font-bold">Documents</h3>
                <Button type="button" size="sm">
                    <PlusIcon />
                    Superbill
                </Button>
            </div>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead variant="plain" className="w-22">
                            Date
                        </TableHead>
                        <TableHead variant="plain">Document</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <EmptyTableState colSpan={2} message="No documents yet" tone="default">
                        <Button type="button">Create Superbill</Button>
                    </EmptyTableState>
                </TableBody>
            </Table>
        </section>
    );
}
